export default __webpack_public_path__ + "transfix-maps/icons/D3-newWave.f0bc3304f7d3eb6156aea3f28bfcf545.png";